<template>
	<div class="medication analysis">
		<div class="card">
			<h5>Scheduled Adherence</h5>
			<el-table
				:data="orderedCompliance"
				:show-header="false"
				max-height="300px">
				<el-table-column label="Date" width="200">
					<template slot-scope="scope">
						<strong class="date">{{ formatDate(weekStart(scope.row.time)) }}</strong>
						to
						<strong class="date">{{ formatDate(weekEnd(scope.row.time)) }}</strong>
					</template>
				</el-table-column>

				<!-- Value -->
				<el-table-column label="Value" width="200">
					<template slot-scope="scope">
						<strong v-bind:class="['status', statusClass(scope.row.status)]">
							<i :class="statusIcon(scope.row.status)"></i>
							{{ statusText(scope.row.status) }}
						</strong>
					</template>
				</el-table-column>

				<!-- Details -->
				<el-table-column label="Value">
					<template slot-scope="scope">
						<span class="detail">Recorded on {{ formatDate(scope.row.created) }}</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
import formatDate from '@/module/util/format-date'
const ONE_DAY = 86400000
const ONE_WEEK = 604800000

const STATUS_ICON = [
	'el-icon-success',
	'el-icon-warning',
	'el-icon-error'
]
const STATUS_CLASS = [
	'success',
	'warning',
	'danger'
]
const STATUS_TEXT = [
	'Always',
	'Sometimes',
	'Never'
]

export default {
	name: 'patient-medication-card-compliance',

	props: {
		id: {
			type: String
		},
		medication: {
			type: Object
		}
	},

	methods: {
		formatDate,
		weekStart(time) {
			return time - time % ONE_WEEK - ONE_DAY * 3
		},
		weekEnd(time) {
			return time - time % ONE_WEEK + ONE_DAY * 3
		},
		statusIcon(status) {
			return STATUS_ICON[status]
		},
		statusText(status) {
			return STATUS_TEXT[status]
		},
		statusClass(status) {
			return STATUS_CLASS[status]
		}
	},

	computed: {
		orderedCompliance() {
			return this.medication.compliance.slice().sort((a, b) => (a.time - b.time))
		}
	}
}
</script>
<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";
@import "../../component/table/style/analysis.scss";

.status.success {
	color: $success-color;
}
.status.warning {
	color: $warning-color;
}
.status.danger {
	color: $danger-color;
}
.detail {
	color: $gray-color;
}
</style>
